import { render, staticRenderFns } from "./order_table.vue?vue&type=template&id=2c80c7af&scoped=true"
import script from "./order_table.vue?vue&type=script&lang=ts"
export * from "./order_table.vue?vue&type=script&lang=ts"
import style0 from "./order_table.vue?vue&type=style&index=0&id=2c80c7af&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c80c7af",
  null
  
)

export default component.exports